// Append Squarespace CDN format param so we request appropriately sized images.
// Squarespace CDN supports `?format=Xw` to return a resized version.
export function optimizeImage(url, width = 1200) {
    if (!url || typeof url !== "string") return url;
    if (!url.includes("squarespace-cdn.com")) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}format=${width}w`;
}
